import _ from 'lodash';

const isOldIeVersion = () => {

  const isIe10 = () => {
    return navigator.appVersion.indexOf('MSIE 10') !== -1;
  };

  const oldVersions = [7, 8, 9];
  let ie = false;
  for (let version in oldVersions) {
    if (_.includes(navigator.appVersion, 'MSIE')) {
      ie = (parseInt(navigator.appVersion.split('MSIE')[1], 10) === version);
    }
  }
  return ie || isIe10();
};

const isMobile = () => {
  const userAgent = navigator.userAgent;
  return /(iPhone)/g.test(userAgent) || /(Android)/g.test(userAgent);
};

const isIe = () => {
  return ((navigator.appName === 'Microsoft Internet Explorer') ||
    ((navigator.appName === 'Netscape') &&
      (new RegExp('Trident/.*rv:([0-9]+[.0-9]*)').exec(navigator.userAgent) !== null)));
};

const isEdge = () => {
  return _.includes(navigator.userAgent, 'Edge');
};

export const BrowserChecker = {
  isIe () {
    return isOldIeVersion() || isIe();
  },
  isEdge () {
    return isEdge();
  },
  isMobile () {
    return isMobile();
  },
  isLegacy () {
    return isOldIeVersion();
  }
};
